import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { describeError } from "./describeError";
import { ErrorScreen } from "./ErrorScreen";

/**
 * Barrière d'erreur des ROUTES — branchée en `errorElement`.
 *
 * ## Pourquoi elle existe
 * Sans elle, React Router affiche sa page de secours : « Unexpected Application
 * Error! », la stack trace, et un mot adressé au développeur. Sur un incident
 * en production, un client d'Alomain se retrouvait devant du texte anglais et
 * un extrait de code, sans même un moyen de revenir à l'accueil.
 *
 * ## Deux natures d'erreur, deux discours
 * - **Réponse HTTP** (`isRouteErrorResponse`) : le serveur a répondu, on peut
 *   nommer le problème (404, 403…).
 * - **Exception JS** : quelque chose a cassé dans l'app. On ne tente pas de
 *   l'expliquer au client — on lui donne deux sorties.
 */
export function AppErrorBoundary() {
  const error = useRouteError();
  const isResponse = isRouteErrorResponse(error);

  const title = isResponse && error.status === 404 ? "Page introuvable" : "Une erreur est survenue";

  const message = isResponse
    ? error.status === 404
      ? "Cette adresse ne correspond à aucun écran d'Alomain."
      : `Le serveur a répondu ${error.status}. Réessayez dans un instant.`
    : "Quelque chose s'est mal passé de notre côté. Vos données ne sont pas perdues — reprenez où vous en étiez.";

  return <ErrorScreen title={title} message={message} detail={describeError(error)} />;
}
